<template>
    <div style="position: relative;">
        <transition name="vue-table-loader">
	        <div class="vue-table-loader" v-if="loading"><span class="fa fa-cog fa-spin fa-3x"></span></div>
	    </transition>
        <job-details v-if="uiStates.showDetails" :job-id="jobSelectedId" @close-details="closeDetailsClick('row_link_'+jobSelectedId)"></job-details>
        <div v-show="!uiStates.showDetails" class="col-md-12">
            <div class="card panel panel-default actions">
                <div class="card-block">
                    <div class="header-block clearfix">
                        <h3 class="pull-left">Jobs</h3>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <base-filter-bar placeholder="Search Jobs"></base-filter-bar>
                </div>
                <div class="col-md-8">
                    <base-select-visible :per-page="perPage" :amounts-shown="amountsShown"></base-select-visible>
                </div>
            </div>
            <div class="product-form-tab">
                <div class="dataTables_wrapper container-fluid dt-bootstrap4 modern">
                    <vuetable ref="vuetable"
                        :api-url="grid"
                        :fields="fields"
                        :css="css.table"

                        noDataTemplate="No Jobs Found"
                        :per-page="perPage"
                        :append-params="moreParams"
                        @vuetable:loaded="onLoaded"
                        pagination-path=""
                        @vuetable:pagination-data="onPaginationData"
                    >
                    <template
                        slot="anchor-slot"
                        slot-scope="fields"
                    >
                        <a :id="'row_link_'+fields.rowData.id"></a>
                    </template>
                    <template
                        slot="view"
                        slot-scope="fields"
                    >
                        <button :href="`/jobs/${fields.rowData.id}/details`" class="btn btn-primary btn-sm" @click="handleDetailsClick(fields.rowData.id)">
                            <i class="fa fa-eye" style="color: #fff;"></i>
                        </button>
                    </template>
                    </vuetable>
                    <div class="row">
                        <div class="col-md-6">
                            <base-pagination-info
                                :css="css.table"
                                ref="paginationInfo"
                            >
                            </base-pagination-info>
                        </div>
                        <div class="col-md-6">
                            <base-pagination  ref="pagination"
                                :show-first-and-last-links="true"
                                @vuetable-pagination:change-page="onChangePage"
                            ></base-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";

var base_url = window.location.protocol + "//" + window.location.host

import Vue from 'vue';
import VueEvents from 'vue-events'
import _ from "lodash";
import BaseSelectVisible from '../tables/base-select-visible.vue';
import BasePagination from '../tables/base-pagination.vue';
import BasePaginationInfo from '../tables/base-pagination-info.vue';
import BaseFilterBar from '../tables/base-filter-bar.vue';
import JobDetails from './job-details.vue';
import moment from "moment-timezone";

Vue.use(VueEvents)

export default {
    name: 'jobs-index',
    props: [],
    components: {
        'base-filter-bar': BaseFilterBar,
        'base-select-visible': BaseSelectVisible,
        'base-pagination': BasePagination,
        'base-pagination-info': BasePaginationInfo,
        'job-details': JobDetails,
    },
    data: function() {
        return {
            jobSelectedId: 0,
            perPage: 25,
            moreParams: {},
            selected: null,
            loading: true,
            details: 0,
            uiStates: {
                errorMessage: true,
                showLoading: true,
                showDetails: false,
            },
            grid: base_url + '/pimapi/jobs',
            fields: [
                {
                    name: 'id',
                    title: 'ID',
                },
                {
                    name: 'name',
                    title: 'Name',
                },
                {
                    name: 'status',
                    title: 'Status',
                },
                {
                    name: 'created_at',
                    title: 'Created At',
                    callback: 'formatDate',
                },
                {
                    name: "__slot:anchor-slot",
                    title: "",
                },
                {
                    name: "__slot:view",
                    title: "",
                },
            ],
            amountsShown: [
                { text: '10', value: 10 },
                { text: '25', value: 25 },
                { text: '50', value: 50 },
                { text: '100', value: 100 },
                { text: '200', value: 200 }
            ],
            css: {
                table: {
                    tableClass: 'table table-middle table-minimal',
                    ascendingIcon: 'sort-icon-asc',
                    descendingIcon: 'sort-icon-desc',
                    detailRowClass: 'vuetable-detail-row',
                    infoClass: '',
                },
            },
            clientTimezone: null
        }
    },
    mounted() {
        this.$events.$on('per-page', eventData => this.doVisibleSet(eventData))
        this.$events.$on('filter-set', eventData => this.onFilterSet(eventData))
        this.$events.$on('filter-reset', e => this.onFilterReset())
        this.getClientTimezone();
    },
    methods : {
        handleDetailsClick(id) {
            this.jobSelectedId = id;
            this.uiStates.showDetails = true;

            history.pushState({}, '', `/jobs/${id}/details`);
        },
        closeDetailsClick(jobSelected) {
            this.uiStates.showDetails = false;
            this.details = jobSelected;
            history.pushState({}, '', `/jobs`);
        },
        onLoaded: function() {
            this.loading = false;
        },
        onPaginationData (paginationData) {
            this.$refs.pagination.setPaginationData(paginationData)
            this.$refs.paginationInfo.setPaginationData(paginationData)
        },
        onChangePage (page) {
            this.$refs.vuetable.changePage(page)
        },
        doVisibleSet (perPageValue) {
            this.perPage = perPageValue;
            Vue.nextTick( () => this.$refs.vuetable.refresh())
        },
        onFilterSet(query) {
            this.loading = true
            this.moreParams = {
                'filter': query
            };
            Vue.nextTick(() => this.$refs.vuetable.refresh());
        },
        onFilterReset () {
            this.moreParams = {}
            Vue.nextTick( () => this.$refs.vuetable.refresh())
        },
        getClientTimezone: function() {
            axios
                .get(
                    base_url +
                    "/client-timezone/",
                    {
                        // 'criteria': criteria,
                    }
                )
                .then(
                    function(response) {
                        this.clientTimezone = response.data.clientTimezone
                    }.bind(this)
                )
                .catch(
                );
        },
        formatDate(value) {
            if (value === null) {
                return '';
            }
            if (this.clientTimezone) {
                return moment.utc(value).tz(this.clientTimezone).format('MMM Do YYYY h:mm a');
            } else{
                return moment(value).format("MMM Do YYYY, h:mm a");
            }

        }
    },
    watch: {
        'perPage' (val, oldVal) {
            this.$nextTick(function() {
                this.$refs.vuetable.refresh()
            })
		},
        details (val, oldVal) {
            this.$nextTick(() => {
                const row_anchor = document.getElementById(val);
                const pos = row_anchor.getBoundingClientRect();

                window.scrollTo({
                    top: pos.top + window.scrollY - 110,
                    behavior: 'smooth'
                });
            })
        }
    }
}
</script>

<style lang="scss">
    .table-minimal {
        margin-bottom: 0px !important;
    }
    .form-line-break {
        margin-bottom: 35px;
    }
    .messaging{
        color: #566670;
        position: absolute;
        bottom: 2px;
        right: 5px;
        font-size: 9px;
    }
</style>
